import {
  Component,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IGif } from '@giphy/js-types';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'src/app/services/api-services/api.service';
import { showError } from 'src/app/utility/common-logic';
import { LangService } from '../../services/lang.service';

interface DialogData {
  dialogMode: boolean;
  gif?: IGif;
}

@Component({
  selector: 'app-add-gif',
  templateUrl: './add-gif.component.html',
  styleUrls: ['./add-gif.component.scss'],
})
export class AddGifComponent implements OnInit {
  @Input() isAddPostPoll = '';
  @Input() isOpen = false;
  @Output() goBack = new EventEmitter();
  klipyApikey: string = '';
  gifs: IGif[] = [];
  key = '';
  gif: IGif | undefined;
  prevGif: IGif | undefined;
  @Output() gifChange = new EventEmitter<IGif>();
  loading = false;
  loadingGiphyApiKey = false;
  constructor(
    private lang: LangService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private api: ApiService,
    private toastr: ToastrService,
    private translate: TranslateService,
  ) {}

  async ngOnInit() {
    if (!!this.data?.gif) {
      this.gif = this.data?.gif;
    }
    this.loadingGiphyApiKey = true;
    const params = `?name=klipy`;
    await this.api
      .getGiphyApiKey(params)
      .then((res) => {
        if (res?.api_key) {
          this.klipyApikey = res?.api_key;
        }
      })
      .catch((err) => showError(err, this.toastr, this.translate))
      .finally(() => (this.loadingGiphyApiKey = false));
    this.prevGif = this.gif;
    if (!this.loading) {
      await this.getImages();
    }
  }

  onGoBack() {
    this.gif = this.prevGif;
    this.goBack.emit();
  }

  @HostListener('document:keyup.escape') onKeydownHandler() {
    if ((this.isAddPostPoll && this.isOpen) || !this.isAddPostPoll) {
      if (this.gif?.id === this.prevGif?.id) {
        this.goBack.emit();
      } else {
        this.gif = this.prevGif;
      }
    }
  }

  async getImages(term: string = 'appreciate') {
    this.loading = true;
    this.api
      .getKlipyGifs(this.klipyApikey, term, this.lang?.lang || 'en')
      .subscribe({
        next: (res) => {
          this.gifs = res;
          this.loading = false;
        },
        error: (err) => {
          showError(err, this.toastr, this.translate);
          this.loading = false;
        },
      });
  }
  async searchImages() {
    if (this.key.length > 2) {
      await this.getImages(this.key);
    } else {
      await this.getImages();
    }
  }

  selectedClass(gif: IGif) {
    return this.gif?.id === gif?.id ? 'selected' : '';
  }

  get disabled() {
    return !this.gif;
  }

  get disabledClass() {
    return this.disabled ? 'disabled' : '';
  }

  continue() {
    if (!this.gif) {
      return;
    }
    this.gifChange.emit(this.gif);
  }
}
